'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LibraryNavBarDropDown = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(LibraryNavBarDropDown, _React$Component);

  function LibraryNavBarDropDown() {
    (0, _classCallCheck3.default)(this, LibraryNavBarDropDown);

    var _this = (0, _possibleConstructorReturn3.default)(this, (LibraryNavBarDropDown.__proto__ || (0, _getPrototypeOf2.default)(LibraryNavBarDropDown)).call(this));

    _this.handleWindowClick = _this.handleWindowClick.bind(_this);

    _this.state = {
      open: false
    };
    return _this;
  }

  (0, _createClass3.default)(LibraryNavBarDropDown, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (__CLIENT__) {
        window.removeEventListener('click', this.handleWindowClick);
      }
    }
  }, {
    key: 'handleWindowClick',
    value: function handleWindowClick(ev) {
      this.setState({
        open: false
      });
    }
  }, {
    key: 'handleClick',
    value: function handleClick(ev) {
      this.setState({
        open: !this.state.open
      });

      if (this.state.open) {
        window.removeEventListener('click', this.handleWindowClick);
      } else {
        window.addEventListener('click', this.handleWindowClick);
      }

      ev.stopPropagation();
    }
  }, {
    key: 'render',
    value: function render() {
      var _classnames;

      var open = this.state.open;
      var _props = this.props,
          value = _props.value,
          options = _props.options,
          propsName = _props.name;


      var styles = require('./LibraryNavBarDropDown.scss');
      var name = propsName || (options.find(function (t) {
        return t.value == value;
      }) || options[0]).name;

      var optionsClasses = (0, _classnames3.default)((_classnames = {}, (0, _defineProperty3.default)(_classnames, styles.DropDown__options, true), (0, _defineProperty3.default)(_classnames, styles['DropDown__options--open'], open), _classnames));

      return _react2.default.createElement(
        'div',
        { className: styles.DropDown, onClick: this.handleClick.bind(this) },
        _react2.default.createElement(
          'span',
          { className: styles.DropDown__value },
          name
        ),
        _react2.default.createElement(
          'ul',
          { className: optionsClasses },
          options.map(function (o) {
            return _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                _reactRouter.Link,
                { to: o.to || '', className: styles.DropDown__option },
                o.name
              )
            );
          })
        )
      );
    }
  }]);
  return LibraryNavBarDropDown;
}(_react2.default.Component), _class.propTypes = {
  name: _react2.default.PropTypes.string,
  options: _react2.default.PropTypes.array,
  value: _react2.default.PropTypes.string
}, _class.defaultProps = {
  options: [],
  value: ''
}, _temp);
exports.default = LibraryNavBarDropDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LibraryNavBarDropDown/LibraryNavBarDropDown.jsx
// module id = 2638
// module chunks = 0